import { Component, Input, OnInit } from '@angular/core';
// Models
import { LayoutRenderLayoutItem } from '../../../models/cv-layout-render.model';
import { RoomLayoutOptions } from '../../models/components.options';

@Component({
	selector: 'cv-schema-render-room-layout',
	templateUrl: './room-layout.component.html',
})
export class RoomLayoutComponent implements OnInit {
	@Input() data: any;
	@Input() layoutNode = new LayoutRenderLayoutItem();

	options = new RoomLayoutOptions();

	ngOnInit(): void {
		this.options = { ...this.options, ...this.layoutNode.options };
	}

}
